import { Form, Skeleton } from "antd";

import { UpdateContactForm } from "Pages/orchestration/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/Components/JourneyActionsPanel/NodeEditorPanel/Components/UpdateContactFormItems/constants";
import { useContactAttributesEditableQuery } from "ServerData/EventSchema/Hooks/useContactAttributesQuery/useContactAttributesQuery";

import { generateUpdateProfileCollapsePanel } from "../../utils";
import { useUpdateContactPanels } from "../Shared/Hooks/useUpdateContactPanels/useUpdateContactPanels";
import { UpdateProfileFormItems } from "./Components/UpdateProfileFormItems/UpdateProfileFormItems";
import { UpdateProfilePanelsLayout } from "./Components/UpdateProfilePanelsLayout/UpdateProfilePanelsLayout";

import type { EventSchemaOptionEntry } from "ServerData/EventSchema/eventSchemaTypes";

type ContactAttrFormPanelContentProps = {
    contactAttributes: EventSchemaOptionEntry;
};

export function UpdateContactFormPanelProfile(): JSX.Element {
    const [form] = Form.useForm();

    const { loading, contactAttributes } = useContactAttributesEditableQuery({});
    const activePanels = Array.from({ length: 99 }, (_, i) => i);
    const { addFormPanel, panelsList } = useUpdateContactPanels<ContactAttrFormPanelContentProps>({
        form,
        generatePanel: generateUpdateProfileCollapsePanel,
        listName: UpdateContactForm.profileListName,
        itemName: UpdateContactForm.profileAttrName,
        // @ts-expect-error complex types
        itemComponent: UpdateProfileFormItems,
        itemComponentProps: {
            contactAttributes,
        },
    });
    return (
        <>
            {loading && <Skeleton></Skeleton>}
            {!loading && (
                <UpdateProfilePanelsLayout
                    addPanel={addFormPanel}
                    activeKey={activePanels}
                    panelsList={panelsList}
                ></UpdateProfilePanelsLayout>
            )}
        </>
    );
}
